var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGridviewGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid_view_-_Grey",
    "data-name": "Grid view - Grey",
    transform: "translate(-154 -449)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4365",
    "data-name": "Rectangle 4365",
    width: 20,
    height: 20,
    transform: "translate(154 449)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_63645",
    "data-name": "Group 63645",
    transform: "translate(-1429 -259.429)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33694",
    "data-name": "Path 33694",
    d: "M-19039.953-7188.73v13.694h5.209v-13.694Z",
    transform: "translate(20624 7900)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33695",
    "data-name": "Path 33695",
    d: "M-19030.889-7188.73v6.144h11.662v-6.144Z",
    transform: "translate(20621.34 7900)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33696",
    "data-name": "Path 33696",
    d: "M-19030.889-7178.191v6.456h5.154v-6.456Z",
    transform: "translate(20621.34 7896.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33697",
    "data-name": "Path 33697",
    d: "M-19021.971-7178.191v6.509h5.256v-6.509Z",
    transform: "translate(20618.723 7896.908)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridviewGrey);
export default __webpack_public_path__ + "static/media/Grid view - Grey.bf773e65f86601eeee21c328b5038f1b.svg";
export { ForwardRef as ReactComponent };